  import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  apiCategoryAll: [],
  apiCategory: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "categoryName",
  sortOrder: "asc",
};

const apiCategorySlice = createSlice({
  name: "apiCategory",
  initialState,
  reducers: {
    setApiCategoryAll: (state, action) => {
      state.apiCategoryAll = action.payload;
    },
    setApiCategory: (state, action) => {
      state.apiCategory = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setApiCategoryAll,
  setApiCategory,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = apiCategorySlice.actions;

export default apiCategorySlice.reducer;
